import { render } from "./ScannerConfig.vue?vue&type=template&id=4a874b45"
import script from "./ScannerConfig.vue?vue&type=script&lang=ts"
export * from "./ScannerConfig.vue?vue&type=script&lang=ts"

import "./ScannerConfig.vue?vue&type=style&index=0&id=4a874b45&lang=scss"
script.render = render

export default script